export default function VolumeAssignedV5({ 
    exercise,
    set,
    isSkipped,
    isCompleted,
}) {
    if (isSkipped === 1 || isCompleted === 1) {
        return null
    }

    var setUnitsAssigned = set?.setUnitsAssigned ?? 0

    return (
        <div className='space-y-2'>
            <div className='text-xs text-center text-gray-600'>
                {exercise.setUnit === 'reps' && <>Target Reps</>}
                {exercise.setUnit === 'seconds' && <>Target Hold</>}
            </div>

            <div className='w-20 h-20 rounded-xl flex items-center justify-center border border-gray-400 bg-white relative'>
                <p className="text-4xl text-center text-gray-900 mb-3">
                    {setUnitsAssigned}
                </p>

                <div className='absolute bottom-2 left-0 w-full text-center text-xs text-gray-800'>
                    {exercise.setUnit === 'reps' &&
                        <>
                            {exercise.lateral === 'unilateral' && <>per side</>}
                            {exercise.lateral === 'bilateral' && <>total</>}
                        </>
                    }
                    {exercise.setUnit === 'seconds' && 
                        <>
                            {exercise.lateral === 'unilateral' && <>sec / side</>}
                            {exercise.lateral === 'bilateral' && <>seconds</>}
                        </>
                    }
                </div>
            </div>
        </div>
    )
}